export default __webpack_public_path__ + "static/media/MultiLocations.f723d814.png";